var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { debugRoot, debugArea, debugGap } from '../../../../styles/debugStyles';
var truncateStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
var layoutStyles = {
    root: function (_a) {
        var props = _a.props;
        var _b;
        var alignItems = props.alignItems, debug = props.debug, gap = props.gap, justifyItems = props.justifyItems, main = props.main, mainSize = props.mainSize, end = props.end, endSize = props.endSize, rootCSS = props.rootCSS, start = props.start, startSize = props.startSize, vertical = props.vertical;
        return __assign({}, (debug && debugRoot()), (_b = { justifyItems: justifyItems,
                alignItems: alignItems, display: 'grid' }, _b[vertical ? 'gridTemplateRows' : 'gridTemplateColumns'] = [
            // Heads up!
            // IE11 Doesn't support grid-gap, insert virtual columns instead
            start && startSize,
            gap && start && main && gap,
            main && mainSize,
            gap && (start || main) && end && gap,
            end && endSize,
        ]
            .filter(Boolean)
            .join(' '), _b), (vertical && {
            gridAutoFlow: 'row',
        }), rootCSS);
    },
    gap: function (_a) {
        var props = _a.props;
        return (__assign({}, (props.debug && debugGap({ vertical: props.vertical }))));
    },
    start: function (_a) {
        var props = _a.props;
        return (__assign({}, (props.debug && debugArea()), (props.truncateStart && truncateStyle), { display: 'inline-flex', alignItems: 'center' }, props.startCSS));
    },
    main: function (_a) {
        var props = _a.props;
        return (__assign({}, (props.debug && debugArea()), (props.truncateMain && truncateStyle), props.mainCSS));
    },
    end: function (_a) {
        var props = _a.props;
        return (__assign({}, (props.debug && debugArea()), (props.truncateEnd && truncateStyle), { display: 'inline-flex', alignItems: 'center' }, props.endCSS));
    },
};
export default layoutStyles;
